import React from "react";
import styled from "styled-components";
import Section from "./Section";
import ReactFullpage from "@fullpage/react-fullpage";

function Home() {
  return (
    <ReactFullpage
      //fullpage options
      licenseKey={"YOUR_KEY_HERE"}
      scrollingSpeed={800} /* Options here */
      render={() => {
        return (
          <Container>
            <Section
              title="Automation System Integrator"
              description="Order Online for Touchless Delivery"
              backgroundImg="automation-system-integrate.jpg"
              leftBtnText="Custom order"
              rightBtnText="Existing Inventory"
            />
            <Section
              title="Robots Developer"
              description="Order Online for Touchless Delivery"
              backgroundImg="universal-robots.jpg"
              leftBtnText="Custom order"
              rightBtnText="Existing Inventory"
            />
            <Section
              title="Warehouse Management System"
              description="Order Online for Touchless Delivery"
              backgroundImg="warehouse-management-system.jpg"
              leftBtnText="Custom order"
              rightBtnText="Existing Inventory"
            />
            <Section
              title="Internet of Things"
              description="Money-back guarantee"
              backgroundImg="internet-of-things.jpg"
              leftBtnText="Order now"
              rightBtnText="Learn more"
            />
            <Section
              title="Full-Stack Development"
              description="Cloud and Microservices with Kubernetes"
              backgroundImg="full-stack-development.jpg"
              leftBtnText="Order now"
              rightBtnText="Learn more"
            />
            <Section
              title="Mobile Developer"
              description="Dedicated Mobile Development"
              backgroundImg="Mobile-app-development-vector-iso.jpg"
              leftBtnText="Shop now"
            />
          </Container>
        );
      }}
    />
  );
}

export default Home;

const Container = styled.div`
  height: 100vh;
  z-index: 10;
`;
